import React from 'react';
import { Button } from '@/components/ui/button';
import { Calendar, Phone, Clock, MapPin, ArrowRight } from 'lucide-react';

export const CTASection = () => {
  return (
    <section className="py-20 lg:py-28 bg-primary relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-primary-foreground/5 rounded-full blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-primary-foreground/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-primary-foreground space-y-6">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
              Ready to Restore Your Hand Function?
            </h2>
            <p className="text-lg text-primary-foreground/90 max-w-lg">
              Don't let hand pain limit your life. Our fellowship-trained specialists 
              are ready to help you get back to doing what you love. Schedule your 
              consultation today.
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button variant="white" size="xl" asChild>
                <a 
                  href="https://app.acuityscheduling.com/schedule.php?owner=13861726"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2"
                >
                  <Calendar className="w-5 h-5" />
                  Schedule Now
                  <ArrowRight className="w-5 h-5" />
                </a>
              </Button>
              <Button 
                variant="heroOutline" 
                size="xl" 
                asChild
              >
                <a href="tel:321-500-4263" className="flex items-center gap-2">
                  <Phone className="w-5 h-5" />
                  Call 321.500.4263
                </a>
              </Button>
            </div>
          </div>

          {/* Info Cards */}
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl p-6 text-primary-foreground">
              <Clock className="w-8 h-8 mb-4" />
              <h3 className="font-display text-xl font-semibold mb-2">Office Hours</h3>
              <p className="text-primary-foreground/80">Monday - Friday</p>
              <p className="font-semibold">8:00 AM - 5:00 PM</p>
            </div>
            
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl p-6 text-primary-foreground">
              <MapPin className="w-8 h-8 mb-4" />
              <h3 className="font-display text-xl font-semibold mb-2">Location</h3>
              <p className="text-primary-foreground/80">2010 W. Eau Gallie Blvd</p>
              <p className="font-semibold">Suite 104, Melbourne, FL</p>
            </div>
            
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl p-6 text-primary-foreground">
              <Phone className="w-8 h-8 mb-4" />
              <h3 className="font-display text-xl font-semibold mb-2">Phone</h3>
              <p className="text-primary-foreground/80">Call or Text</p>
              <p className="font-semibold">321.500.HAND (4263)</p>
            </div>
            
            <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl p-6 text-primary-foreground">
              <Calendar className="w-8 h-8 mb-4" />
              <h3 className="font-display text-xl font-semibold mb-2">Appointments</h3>
              <p className="text-primary-foreground/80">Same-Day Available</p>
              <p className="font-semibold">Telemedicine Options</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
